<template>
    <section class="bg-lifeboost-orange-100">
        <div class="px-4 mx-auto max-w-screen-2xl md:py-28 py-14 lg:px-6 sm:px-7 md-max:pb-24">
            <div class="max-w-4xl mx-auto font-bold text-center text-white title-mushroom md:px-10 font-ww-medium" v-html="headingText">
            </div>
            <div class="grid grid-cols-1 mt-8 md:mt-20 md:grid-cols-2 gap-y-4 lg:gap-x-14 md:gap-x-6">
                <div class="space-y-8 md:space-y-12">
                    <div class="" v-for="(item, index) in questions.slice(0, questions.length / 2)" :key="index">
                        <div class="p-6 space-y-6 text-white border border-black cursor-pointer sm:p-11 md:p-10 lg:p-12 rounded-3xl"
                            @click="toggleVisibility(item.id)">
                            <div class="flex items-center justify-between gap-x-2">
                                <div class="leading-41 text-35 font-ww-medium">
                                    {{ item.question }}
                                </div>
                                <div class="">
                                    <svg class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="19px">
                                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                                            d="M16.326,18.257 C15.683,18.386 14.989,18.202 14.490,17.703 L0.867,4.080 C0.075,3.289 0.074,2.005 0.865,1.214 C1.656,0.423 2.939,0.424 3.731,1.216 L16.023,13.508 L28.324,1.207 C29.115,0.416 30.398,0.417 31.190,1.209 C31.982,2.001 31.983,3.284 31.192,4.075 L17.587,17.680 C17.235,18.032 16.785,18.218 16.326,18.257 Z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="pt-8 md:pt-8" v-show="item.visible">
                                <div class="font-light font-ww-regular text-28 leading-41" v-html="item.answer"></div>
                                <ul class="grid pl-5 gap-y-1" v-if="item.list" :class="item.listType ? item.listType : ''">
                                    <li v-for="(listItem, idx) in item.list" :key="idx">
                                        {{ listItem }}
                                    </li>
                                </ul>
                                <p class="m-4" v-html="item.extraText" v-if="item.extraText"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="space-y-8 md:space-y-12">
                    <div class="" v-for="(item, index) in questions.slice(questions.length / 2, questions.length)"
                        :key="index">
                        <div class="p-6 space-y-6 text-white border border-black cursor-pointer sm:p-11 md:p-10 lg:p-12 rounded-3xl"
                            @click="toggleVisibility(item.id)">
                            <div class="flex items-center justify-between gap-x-2">
                                <div class="leading-41 text-35 font-ww-medium">
                                    {{ item.question }}
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="17px">
                                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                                            d="M16.326,18.257 C15.683,18.386 14.989,18.202 14.490,17.703 L0.867,4.080 C0.075,3.289 0.074,2.005 0.865,1.214 C1.656,0.423 2.939,0.424 3.731,1.216 L16.023,13.508 L28.324,1.207 C29.115,0.416 30.398,0.417 31.190,1.209 C31.982,2.001 31.983,3.284 31.192,4.075 L17.587,17.680 C17.235,18.032 16.785,18.218 16.326,18.257 Z" />
                                    </svg>
                                </div>
                            </div>
                            <div class="text-base" v-show="item.visible">
                                <div class="font-light font-ww-regular text-28 leading-41" v-html="item.answer"></div>
                                <ul class="grid pl-5 gap-y-1" v-if="item.list">
                                    <li v-for="(listItem, idx) in item.list" :key="idx">
                                        {{ listItem }}
                                    </li>
                                </ul>
                                <p class="mt-4" v-html="item.extraText" v-if="item.extraText"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-8 md:mt-20">
                <button @click="scrollTo('the-products',scrollPosition(mobilePosition))" class="flex items-center bnt-icon md-max:w-full">
                    <span class="flex items-center" v-html="buttonText"></span>
                    <svg class="relative ml-4 top-0.5 sm:w-auto w-8" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="38px" height="31px" viewBox="0 0 38 31">
                        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                            d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z"></path>
                    </svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    headingText: {
        type: String,
        default: "Frequently Asked Questions",
    },
    buttonText: {
        type: String,
        default: "Try it now",
    },
    buttonLink: {
        type: String,
        default: "#the-products",
    },
    mobilePosition: {
        type: String,
        default: 'bottom'
    },
    questions: {
        type: Array,
        default: () => [
            {
                question: "How much caffeine is in this coffee?",
                answer: "We use our popular medium roast coffee in every bag of Cognition and upgrade it with high-potency mushroom extracts. Therefore, each cup of coffee contains a standard amount of caffeine you’d find in any high-quality Arabica coffee.",
                visible: true,
                id: 0,
            },
            {
                question: "Is it organic?",
                answer: "Yes. Both the coffee and the mushroom extracts are 100% certified organic.",
                visible: false,
                id: 1,
            },
            {
                question: "Why do you only use two mushrooms?",
                answer: "Lifeboost Cognition includes the two most effective mushrooms for the brain and body (Lion’s Mane + Chaga). We include only high-potency extracts from real mushrooms proven to include sufficient amounts of health-boosting beta-glucans.",
                visible: false,
                id: 2,
            },
            {
                question: "Are there any additives or sweeteners?",
                answer: "Nope! Lifeboost Cognition coffee is sugar-free, gluten-free, grain-free, non-GMO, and Kosher.",
                visible: false,
                id: 3,
            },
            {
                question: "Are functional mushrooms the same as magic mushrooms? Will they make my trip?",
                answer: "These are not psychedelic mushrooms. The two mushrooms used in Cognition, Lion’s Mane and Chaga, have absolutely no psychedelic effects whatsoever.",
                visible: false,
                id: 4,
            },
            {
                question: "What does it taste like?",
                answer: "We’ve specially designed Lifeboost Cognition coffee to include the mind-boosting benefits of real mushrooms without the mushroom taste you hear about other mushroom coffees. But don’t take our word for it - hear from a real customer: “Tastes great, very smooth, no taste of Mushroom 😅 we now have it on auto-ship.” - Natasha Smith, Lifeboost Cognition customer",
                visible: false,
                id: 5,
            },
            {
                question: "Is it ground coffee or beans?",
                answer: "We only offer Lifeboost Cognition in ground coffee because we want the maximum surface area when we add 100% real mushroom extracts. You can make it like any other ground coffee, including via drip, French press, Chemex, Aeropress, or any other way you like! (You can even use a Keurig machine if you have a reusable, refillable pod to put ground coffee into.)",
                visible: false,
                id: 6,
            }
        ],
    },
});

const questions = ref(props.questions.map((q) => ({ ...q, visible: q.visible || false })));

function toggleVisibility(id) {
    questions.value = questions.value.map((item) =>
        item.id === id
            ? { ...item, visible: !item.visible }
            : { ...item, visible: false }
    );
}

defineBuilderComponent({
    friendlyName: "Frequently Questions With CTA",
    inputs: [
        {
            name: "headingText",
            type: "richText",
            friendlyName: "Heading Text",
            defaultValue: "Frequently Asked Questions"
        },
        {
            name: "buttonText",
            type: "string",
            friendlyName: "Button Text",
            defaultValue: "Try it now"
        },
        {
            name: "buttonLink",
            type: "url",
            friendlyName: "Button Link",
            defaultValue: "#the-products"
        },
        {
            name: 'mobilePosition',
            type: 'enum',
            friendlyName: 'Scroll Position mobile',
            enum: [
                { label: 'Bottom', value: 'bottom' },
                { label: 'Top', value: 'top' }
            ],
            defaultValue: 'Bottom',
        },
        {
            name: "questions",
            type: "list",
            friendlyName: "Questions List",
            subFields: [
                { name: "question", type: "string", friendlyName: "Question Text", defaultValue: "" },
                { name: "answer", type: "richText", friendlyName: "Answer Text", defaultValue: "" },
                { name: "visible", type: "boolean", friendlyName: "Is Visible", defaultValue: false },
                { name: "id", type: "number", friendlyName: "Question ID", defaultValue: 0 }
            ],
            defaultValue: [
                {
                    question: "How much caffeine is in this coffee?",
                    answer: "We use our popular medium roast coffee in every bag of Cognition and upgrade it with high-potency mushroom extracts. Therefore, each cup of coffee contains a standard amount of caffeine you’d find in any high-quality Arabica coffee.",
                    visible: true,
                    id: 0
                },
                {
                    question: "Is it organic?",
                    answer: "Yes. Both the coffee and the mushroom extracts are 100% certified organic.",
                    visible: false,
                    id: 1
                },
                {
                    question: "Why do you only use two mushrooms?",
                    answer: "Lifeboost Cognition includes the two most effective mushrooms for the brain and body (Lion’s Mane + Chaga). We include only high-potency extracts from real mushrooms proven to include sufficient amounts of health-boosting beta-glucans.",
                    visible: false,
                    id: 2
                },
                {
                    question: "Are there any additives or sweeteners?",
                    answer: "Nope! Lifeboost Cognition coffee is sugar-free, gluten-free, grain-free, non-GMO, and Kosher.",
                    visible: false,
                    id: 3
                },
                {
                    question: "Are functional mushrooms the same as magic mushrooms? Will they make my trip?",
                    answer: "These are not psychedelic mushrooms. The two mushrooms used in Cognition, Lion’s Mane and Chaga, have absolutely no psychedelic effects whatsoever.",
                    visible: false,
                    id: 4
                },
                {
                    question: "What does it taste like?",
                    answer: "We’ve specially designed Lifeboost Cognition coffee to include the mind-boosting benefits of real mushrooms without the mushroom taste you hear about other mushroom coffees. But don’t take our word for it - hear from a real customer: “Tastes great, very smooth, no taste of Mushroom 😅 we now have it on auto-ship.” - Natasha Smith, Lifeboost Cognition customer",
                    visible: false,
                    id: 5
                },
                {
                    question: "Is it ground coffee or beans?",
                    answer: "We only offer Lifeboost Cognition in ground coffee because we want the maximum surface area when we add 100% real mushroom extracts. You can make it like any other ground coffee, including via drip, French press, Chemex, Aeropress, or any other way you like! (You can even use a Keurig machine if you have a reusable, refillable pod to put ground coffee into.)",
                    visible: false,
                    id: 6
                }
            ]
        }
    ]
});
</script>
